import { ModuleConstants } from '@hrms/common/constant/modules';
import { ComponentsMap } from '@hrms/common/routes/components';
import { ScreenNames } from '@hrms/common/routes/screens';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { generateImage } from '@hrms/common/utils/generateImage';

const approvalBaseRoute = '/approval';

export const RouteConstants = {
  LEAVES: `${approvalBaseRoute}/leaves`,
  SEPARATION: `${approvalBaseRoute}/separations`,
  BGV: `${approvalBaseRoute}/bgv`,
  REGULARISATION: `${approvalBaseRoute}/regularisations`,
  PUNCH_IN: `${approvalBaseRoute}/punch-in`,
  PUNCH_OUT: `${approvalBaseRoute}/punch-out`,
  OT_TOP_UP: `${approvalBaseRoute}/ot-topups`,
  SPOOF: `${approvalBaseRoute}/attendance-spoof`,
  PLANED_OT: `${approvalBaseRoute}/planned-ot`,
  TRANSFERS: `${approvalBaseRoute}/transfers`,
  ABSCONDING: `${approvalBaseRoute}/absconding`,
  POST_ONBOARDING: `${approvalBaseRoute}/post-onboarding`,
};

const approvalChildrenRoutes = [
  {
    id: ModuleConstants.APPROVAL_BGV,
    route: RouteConstants.BGV,
    title: ScreenNames.APPROVAL_BGV,
    component: ComponentsMap.APPROVAL_BGV_LIST,
  },
  {
    id: ModuleConstants.PUNCH_IN_APPROVALS,
    route: RouteConstants.PUNCH_IN,
    title: ScreenNames.PUNCH_IN,
    component: ComponentsMap.PUNCH_IN,
  },
  {
    id: ModuleConstants.PUNCH_OUT_APPROVALS,
    route: RouteConstants.PUNCH_OUT,
    title: ScreenNames.PUNCH_OUT,
    component: ComponentsMap.PUNCH_OUT,
  },
  {
    id: ModuleConstants.SPOOF_APPROVAL,
    route: RouteConstants.SPOOF,
    title: ScreenNames.SPOOF,
    component: ComponentsMap.SPOOF,
  },
  {
    id: ModuleConstants.REGULARIZATION,
    route: RouteConstants.REGULARISATION,
    title: ScreenNames.REGULARISATION,
    component: ComponentsMap.REGULARISATION,
  },
  {
    id: ModuleConstants.PLANNED_OT_APPROVAL,
    route: RouteConstants.PLANED_OT,
    title: ScreenNames.PLANED_OT,
    component: ComponentsMap.PLANED_OT,
  },
  {
    id: ModuleConstants.OT_TOP_UP,
    route: RouteConstants.OT_TOP_UP,
    title: ScreenNames.OT_TOP_UP,
    component: ComponentsMap.OT_TOP_UP,
  },
  {
    id: ModuleConstants.APPROVAL_LEAVES,
    route: RouteConstants.LEAVES,
    title: ScreenNames.APPROVAL_LEAVES,
    component: ComponentsMap.APPROVAL_LEAVES_LIST,
  },
  {
    id: ModuleConstants.APPROVAL_SEPARATION,
    route: RouteConstants.SEPARATION,
    title: ScreenNames.APPROVAL_SEPARATION,
    component: ComponentsMap.APPROVAL_SEPARATION_LIST,
  },
  {
    id: ModuleConstants.APPROVAL_ABSCONDING,
    route: RouteConstants.ABSCONDING,
    title: ScreenNames.APPROVAL_ABSCONDING,
    component: ComponentsMap.APPROVAL_ABSCONDING_LIST,
  },
  {
    id: ModuleConstants.APPROVAL_TRANSFERS,
    route: RouteConstants.TRANSFERS,
    title: ScreenNames.APPROVAL_TRANSFERS,
    component: ComponentsMap.APPROVAL_TRANSFERS,
    children: [
      {
        id: ModuleConstants.TRANSFER_REQUESTS_TRACKER_DETAILS,
        route: `${RouteConstants.TRANSFERS}/:type/:id`,
        title: ScreenNames.TRANSFER_REQUESTS_TRACKER_DETAILS,
        component: ComponentsMap.TRANSFER_REQUESTS_TRACKER_DETAILS,
        sidebarVisibility: false,
      },
      {
        id: ModuleConstants.TRANSFER_REQUESTS_TRACKER_DETAILS,
        route: `${RouteConstants.TRANSFERS}/:type`,
        title: ScreenNames.TRANSFER_REQUESTS_TRACKER_DETAILS,
        component: null,
        sidebarVisibility: false,
      },
    ],
  },
  {
    id: ModuleConstants.APPROVAL_POST_ONBOARDING,
    route: RouteConstants.POST_ONBOARDING,
    title: ScreenNames.POST_ONBOARDING,
    component: ComponentsMap.APPROVAL_POST_ONBOARDING,
  },
];

const getApprovalModuleRoutes: ModuleRoutesComponentInterface = () => [
  {
    id: ModuleConstants.APPROVAL,
    route: approvalBaseRoute,
    title: ScreenNames.APPROVAL,
    icon: generateImage({
      noScale: true,
      name: 'approval',
      alt: 'config',
      className: 'w-4 h-4',
    }),
    component: null,
    children: approvalChildrenRoutes,
  },
];

export default getApprovalModuleRoutes;
